// @ts-nocheck
const CustomerMyTasksSkeleton = () => {

    return (
        <div>Es lädt...</div>
    )
}

export default CustomerMyTasksSkeleton